import { render, staticRenderFns } from "./ApproveMissedShift.vue?vue&type=template&id=5edc9cb4&scoped=true"
import script from "./ApproveMissedShift.vue?vue&type=script&lang=js"
export * from "./ApproveMissedShift.vue?vue&type=script&lang=js"
import style0 from "./ApproveMissedShift.vue?vue&type=style&index=0&id=5edc9cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc9cb4",
  null
  
)

export default component.exports